import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import useFetch from '../../hooks/useFetch';

import './ThinkHealthCard.css';

const ThinkHealthCardVet = ({otherUserCode, petName}) => {
  const authState = useSelector(state => state.authReducer);
  const navigate = useNavigate();
  const [fetchData, { loading }] = useFetch();
  const [userId, setUserId] = useState(authState.user._id);
  const [userName, setUserName] = useState(authState.user.name);
  const [userCode, setUserCode] = useState(authState.user.think5whyscode);

  const [userData, setUserData] = useState([]);

  const fetchHealthCard = useCallback(() => {
    const config = { 
      url: "/tasks/vethealthcard", 
      method: "post", 
      headers: { Authorization: authState.token },
      data: {userCode: userCode}
    };
    // console.log("fetchHealthCard Config: ", config);

    fetchData(config, { showSuccessToast: false })
      .then(({ healthData }) => {
        if (healthData && healthData.length > 0) {
          setUserData(healthData);
        } else {
          // console.log("No health data found");
          setUserData([]); 
        }
      })
      .catch(error => {
          console.error("Error fetching data:", error); 
      });

  }, [authState.token, fetchData, userCode]);

  useEffect(() => {
    if (!authState.isLoggedIn) return;
    fetchHealthCard();
  }, [authState.isLoggedIn, fetchHealthCard]);

  // Function to handle close button click
  const handleClose = () => {
    navigate(-1); // Navigate back to the previous page
  };

  return (
    <div className="overlay">
      <div className="health-card-container">
        <button className="close-button" onClick={handleClose}>✖</button>
        <h1 className="title">Health Card</h1>
        <div className="health-card">
          <h2>Vet Health Card</h2>

          {(!userData || userData.length === 0) ? (
            <p>There are no health records!</p>
          ) : (
            <div>
              {/* Iterate over the userData array */}
              {userData.map((task, index) => (
                <div key={index} className="health-record">
                  <h3>Health Title: {task.healthTitle}</h3>
                  <p><strong>Illness Action:</strong> {task.illnessAction}</p>
                  <p><strong>Health Particulars:</strong> {task.healthParticulars}</p>
                  <p><strong>Health Remarks:</strong> {task.healthRemarks}</p>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ThinkHealthCardVet;
